<template>
  <div>
    <Col style="height: 100%">
      <div class="ivu-select-dropdown" id="s3-file-row-rMenu" style="visibility: hidden">
        <ul class="ivu-dropdown-menu">
          <!--<li class="ivu-dropdown-item" @click="rMenuClick('refresh')"><Icon type="md-refresh"/> 下载</li>-->
          <!--<li class="ivu-dropdown-item" @click="rMenuClick('refresh')"><Icon type="md-refresh"/> 版本</li>-->
          <li class="ivu-dropdown-item" @click="rMenuClick('top')"
              :class="{'u-disabled': searchForm.path === '', 'active': searchForm.path !== ''}"><Icon type="md-arrow-round-back"/> 返回</li>
          <li class="ivu-dropdown-item" @click="rMenuClick('refresh')"><Icon type="md-refresh"/> 刷新</li>
          <!--<li class="ivu-dropdown-item" style="color: rgb(237, 64, 20);">删除</li>-->
        </ul>
      </div>
      <Card class="content backup-manage-index" style="height: 100%;" shadow>
        <div class="main-bucket" v-show="bucketsShow">
          <Alert show-icon>
            <span>请选择桶</span>
          </Alert>
          <Table :loading="load.buckets" :data="bucketData" ref="bucket_table" :columns="bucketColumns" border :max-height="bucketTableHeight"></Table>
        </div>
        <div class="main" v-show="!bucketsShow" style="height: 100%;" @contextmenu.prevent="">
          <div class="main-file" style="height: 100%;" @contextmenu.prevent="divRight">
            <div class="main-file-header" ref="main_file_header">
              <div style="padding:10px; margin-bottom:20px; box-shadow:6px 6px 15px rgba(0,0,0,0.3)">
                <span style="margin-right: 10px">
                  <el-tooltip class="item" effect="dark" content="切换桶" placement="bottom">
                  <el-button :size="listOrGrid === 'tran' ? 'mini' : 'medium'" icon="el-icon-coin" type="info" plain @click="changeBucket">{{ currentBucket }}</el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="还原" placement="bottom">
                    <el-button :size="listOrGrid === 'tran' ? 'mini' : 'medium'" type="primary" @click="restoreSubmit" :disabled="selectData.length <= 0" :loading="load.restoreBtn"  icon="el-icon-folder-add"><span v-if="listOrGrid !== 'tran'">还原</span></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="彻底删除" placement="bottom">
                    <el-button :size="listOrGrid === 'tran' ? 'mini' : 'medium'" type="danger" :disabled="selectData.length <= 0" @click="deleteSubmit" :loading="load.deleteBtn" icon="el-icon-delete"><span v-if="listOrGrid !== 'tran'">彻底删除</span></el-button>
                  </el-tooltip>
                  <!--<el-button size="large" :disabled="selectData.length <= 0">编辑文件夹</el-button>-->
                </span>
                <!-- <span style="float: right">
                  <el-tooltip class="item" effect="dark" content="清空回收站" placement="bottom">
                    <el-button :size="listOrGrid === 'tran' ? 'mini' : 'medium'" type="danger" :disabled="selectData.length <= 0" @click="deleteSubmit" :loading="load.deleteBtn" icon="el-icon-delete"><span v-if="listOrGrid !== 'tran'">清空回收站</span></el-button>
                  </el-tooltip>
                </span> -->
              </div>
            </div>
            <div v-show="listOrGrid === 'list' || listOrGrid === 'tran'" style="height: 100%;">
              <Row style="height: 100%;">
                <Table
                  size="large"
                  no-data-text="暂无文件"
                  :height="tableHeight"
                  ref="backup_file_table"
                  class="backup_file_table"
                  border
                  context-menu
                  @on-contextmenu="rowRightClick"
                  @on-row-click="gridClick"
                  @on-row-dblclick="tableDblClick"
                  @on-selection-change="handleChange"
                  @on-select="selectRow"
                  @on-select-cancel="selectRowCancel"
                  @on-select-all="selectAll"
                  @on-select-all-cancel="selectAllCancel"
                  :row-class-name="rowClassName"
                  :loading="load.folder"
                  :data="file_table_data"
                  :columns="file_table_columns">
                </Table>
              </Row>
            </div>
            <div style="margin: 10px 0; overflow: hidden;">
              <div style="float: right;">
                <page :total="count" :current="page" :page-size="size" @on-change="getFileList"
                      show-total show-sizer show-elevator transfer
                      :page-size-opts="[50, 100, 200]"
                      @on-page-size-change="v => { size = v; getFileList(value=page) }"></page>
              </div>
            </div>
            <div v-show="listOrGrid === 'grid'">
              <Row>
                <spin fix v-if="load.folder"></spin>
                <div v-if="!file_table_data.length" style="text-align: center;">
                  <span style="color: #999; ">暂无文件</span>
                </div>
                <ul class="wl-list" :style="{height: tableHeight + 'px'}">
                  <li
                    class="wl-list-item wl-is-folder"
                    v-for="(i, idx) in file_table_data"
                    :key="idx">
                    <el-checkbox :class="{'wl-checkbox': true, 'wl-checkbox-selected': i._checked}" @change="gridItemCheck($event, i, idx)" v-model="i._checked"></el-checkbox>
                    <div @click="gridClick(i, idx)" @dblclick="i.type === 'dir' ? routerPush(i) : ''">
                      <img :src="fileTypeIcon(i)" class="name-col-icon" alt="文件类型图标">
                      <p class="list-item-name" :title="i.file_name">
                        {{ i.file_name }}
                      </p>
                    </div>
                  </li>
                </ul>
              </Row>
            </div>
          </div>
        </div>
      </Card>
    </Col>
  </div>
</template>

<script>
import { getDeleteFileLists, createDir, deleteObjForever, uploadFileUrl, downloadFile, fileVersions, restoreObjDeleted, getBuckets } from '@/api/s3/s3'
import { valueTranUnit } from '@/libs/tools'
import moment from 'moment'
import folder3xPng from '@/assets/images/file-type/folder@3x.png'
import { mapActions } from 'vuex'

import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import wlTreeSelect from 'wl-vue-select'
import 'wl-vue-select/lib/wl-vue-select.css'
Vue.use(ElementUI)
Vue.use(wlTreeSelect)

export default {
  name: 'recycle',
  data () {
    return {
      count: 0,
      page: 1,
      size: 50,
      bucketTableHeight: 0,
      bucketData: [],
      bucketColumns: [
        {
          title: '桶名称',
          key: 'name',
          minWidth: 300,
          render: (h, params) => {
            return h('a', {
              on: {
                click: () => {
                  this.currentBucket = params.row.name
                  this.currentSupport = params.row.id
                  this.searchForm.path = ''
                  this.bucketsShow = false
                  this.getFileList()
                  this.pathBtn('home')
                }
              }
            }, params.row.name)
          }
        },
        {
          title: '所属服务商',
          key: 'dec',
          minWidth: 300
        },
        {
          title: '创建时间',
          align: 'center',
          width: 300,
          resizable: true,
          render: (h, params) => {
            if (params.row.create_date) {
              return h('span', moment(params.row.create_date).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        }
      ],
      bucketsShow: true,
      tableHeight: 0,
      listOrGrid: 'list',
      fade: {
        folder: false,
        upload: false,
        acl: false
      },
      load: {
        buckets: false,
        deleteBtn: false,
        restoreBtn: false,
        opeDirBtn: false,
        folder: false,
        upload: false,
        versionLoading: false,
        aclLoading: false
      },
      file_table_columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '名称',
          key: 'file_name',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            let fileP = h('span', params.row.file_name)
            return h('div', [
              h('Avatar', {
                props: {
                  src: this.fileTypeIcon(params.row),
                  size: 'small'
                },
                style: {
                  marginRight: '10px'
                }
              }),
              fileP
            ])
          }
        },
        {
          title: '删除时间',
          align: 'center',
          width: 200,
          resizable: true,
          render: (h, params) => {
            if (params.row.last_modified) {
              return h('span', moment(params.row.last_modified).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '类型',
          align: 'center',
          resizable: true,
          width: 100,
          render: (h, params) => {
            return h('span', params.row.type === 'dir' ? '文件夹' : '文件')
          }
        },
        {
          title: '大小',
          key: 'size',
          align: 'center',
          width: 120,
          resizable: true,
          render: (h, params) => {
            if (params.row.size || params.row.size === 0) {
              return h('span', valueTranUnit(params.row.size, 2, 'B'))
            } else {
              return h('span', '-')
            }
          }
        }
      ],
      file_table_data: [],
      folder3xPng: folder3xPng,
      all_folder_list: [],
      folder_form: {
        file_name: '',
        preview: [],
        handle: []
      },
      folder_rules: {
        file_name: [{ required: true, message: '请填写文件夹名称', trigger: 'blur' }]
      },
      searchForm: {
        path: '',
        keyword: ''
      },
      selectData: [],
      path: {
        index: 0,
        history: [
          {
            path: ''
          }
        ]
      },
      uploadFileUrl: uploadFileUrl,
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      versionData: [],
      versionColumns: [
        {
          title: '名称',
          key: 'file_name',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            return h('div', [
              h('Avatar', {
                props: {
                  src: this.fileTypeIcon(params.row),
                  size: 'small'
                },
                style: {
                  marginRight: '10px'
                }
              }),
              h('span', params.row.file_name)
            ])
          }
        },
        {
          title: '修改日期',
          align: 'center',
          width: 230,
          render: (h, params) => {
            if (params.row.last_modified) {
              return h('span', moment(params.row.last_modified).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '大小',
          minWidth: 90,
          key: 'size',
          align: 'center',
          width: 150,
          render: (h, params) => {
            if (params.row.size) {
              return h('span', valueTranUnit(params.row.size, 2, 'B'))
            } else {
              return ''
            }
          }
        },
        {
          title: '版本ID',
          align: 'center',
          key: 'version_id',
          width: 280
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 110,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '5px'
                },
                props: {
                  type: 'info',
                  size: 'small'
                },
                on: {
                  click: () => {
                    let file = this.selectData[0]
                    let data = {
                      name: file.prefix ? file.prefix + '/' + file.file_name : file.file_name,
                      version_id: params.row.version_id
                    }
                    downloadFile(data).then(res => {
                      this.download(res.data.data, file.file_name)
                    })
                  }
                }
              }, '下载')
            ])
          }
        }
      ],
      currentBucket: '',
      currentSupport: '',
      aclData: {},
      currentRClickRow: null,
      timer: null,
      moment: moment,
      message: {
        type: 'success',
        content: '',
        show: false
      }
    }
  },
  created: function () {
    this.getBucketsData()
    if (this.currentBucket) {
      this.getFileList()
    }
  },
  mounted () {
    this.tableHeight = window.innerHeight - 270
    window.onresize = () => {
      return (() => {
        this.tableHeight = window.innerHeight - 270
      })()
    }
  },
  destroyed () {
  },
  activated () {
    if (this.currentBucket) {
      this.getFileList()
    }
  },
  methods: {
    ...mapActions([
      'getUserInfo'
    ]),
    changeBucket () {
      this.bucketsShow = true
      this.currentBucket = ''
      this.file_table_data = []
    },
    // 获取桶数据
    getBucketsData () {
      this.load.buckets = true
      getBuckets().then(res => {
        this.load.buckets = false
        this.bucketData = res.data.data
      }).catch(res => {
        this.load.buckets = false
        console.error(res.response)
      })
    },
    getUserInfoA () {
      this.getUserInfo()
    },
    moreAction (name) {
      if (this.selectData.length <= 0) return
      let file = this.selectData[0]
      if (file.type === 'dir') {
        this.$message.warning('暂不支持操作文件夹')
        return
      }
      switch (name) {
        case ('move'):
          break
        case ('download'):
          let data = {
            name: file.prefix ? file.prefix + '/' + file.file_name : file.file_name
          }
          downloadFile(data).then(res => {
            this.download(res.data.data, file.file_name)
          })
          break
        case ('version'):
          this.getVersions(file)
          break
      }
    },
    pathSelect (val) {
      this.getFileList(prefix = val.value)
    },
    // 判断是否文件夹函数
    isFolderFn (row) {
      return row.type === 'dir'
    },
    // 获取文件夹列表
    getFileList (value = 1, prefix = this.searchForm.path, newPath = true) {
      this.page = value
      let params = {
        size: this.size,
        page: this.page,
        bucket: this.currentBucket,
        prefix: prefix,
        id: this.currentSupport
      }
      if (newPath && prefix !== this.searchForm.path) {
        this.path.history.push({
          path: prefix
        })
        this.path.index += 1
      }
      let oldPath = this.searchForm.path
      this.load.folder = true
      getDeleteFileLists(params).then(res => {
        this.selectData = []
        this.load.folder = false
        this.file_table_data = res.data.data.results || []
        this.count = res.data.data.count
      }).catch(res => {
        this.searchForm.path = oldPath
        this.load.folder = false
        this.$message.error('数据加载异常')
      })
    },
    // 根据文件类型显示图标
    fileTypeIcon (row) {
      let _path = ''
      // 文件夹
      if (this.isFolderFn(row)) {
        _path = require('@/assets/images/file-type/folder@3x.png')
        return _path
      }
      let fileNameSplit = row['file_name'].split('.')
      // 其他根据后缀类型
      let _suffix = fileNameSplit[fileNameSplit.length - 1]
      if (!_suffix) {
        _path = require('@/assets/images/file-type/file_none@3x.png')
        return _path
      }
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_img@3x.png')
      } else if (['zip', 'rar', '7z'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_zip@3x.png')
      } else if (['avi', 'mp4', 'rmvb', 'flv', 'mov', 'm2v', 'mkv'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_video@3x.png')
      } else if (['mp3', 'wav', 'wmv', 'wma'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_mp3@3x.png')
      } else if (['xls', 'xlsx'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_excel@3x.png')
      } else if (['doc', 'docx'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_pdf@3x.png')
      } else if (_suffix === 'pdf') {
        _path = require('@/assets/images/file-type/file_docx@3x.png')
      } else if (_suffix === 'ppt') {
        _path = require('@/assets/images/file-type/file_ppt@3x.png')
      } else if (_suffix === 'txt') {
        _path = require('@/assets/images/file-type/file_txt@3x.png')
      } else {
        _path = require('@/assets/images/file-type/file_none@3x.png')
      }
      return _path
    },
    routerPush (row) {
      let path = row.file_name
      if (row.prefix) {
        path = `${row.prefix}/${path}`
      }
      this.path.history = this.path.history.slice(0, this.path.index + 1)
      this.getFileList(prefix = path)
    },
    rMenuClick (name) {
      switch (name) {
        case 'top':
        case 'refresh':
          this.pathBtn(name)
          break
      }
      this.hideRMenu()
    },
    divRight (event) {
      this.rowRightClick(null, event)
    },
    rowRightClick (row, event) {
      this.currentRClickRow = row
      this.showRMenu(event.clientX, event.clientY)
    },
    showRMenu (x, y) {
      $('#s3-file-row-rMenu ul').show()
      $('#s3-file-row-rMenu').css({ 'top': y - 80 + 'px', 'left': x - 20 + 'px', 'visibility': 'visible' })
      $('body').bind('mousedown', this.onBodyMouseDown)
    },
    hideRMenu () {
      this.currentRClickRow = null
      if ($('#s3-file-row-rMenu')) $('#s3-file-row-rMenu').css({ 'visibility': 'hidden' })
      $('body').unbind('mousedown', this.onBodyMouseDown)
    },
    onBodyMouseDown (event) {
      if (!(event.target.id === 'rMenu' || $(event.target).parents('#s3-file-row-rMenu').length > 0)) {
        $('#s3-file-row-rMenu').css({ 'visibility': 'hidden' })
      }
    },
    rowClassName (row, idx) {
      if (this.currentRClickRow && row.file_name === this.currentRClickRow.file_name) {
        return 'ivu-table-row-highlight'
      }
      return ''
    },
    gridClick (item, idx) {
      this.file_table_data[idx]._checked = !this.file_table_data[idx]._checked
      this.gridItemCheck(this.file_table_data[idx]._checked, item, idx)
    },
    gridItemCheck (c, item, idx) {
      this.$refs.backup_file_table.objData[idx]._isChecked = c
      this.$nextTick(function () {
        this.handleChange(this.$refs.backup_file_table.getSelection())
      })
    },
    handleChange (selectRow) {
      this.selectData = selectRow
    },
    tableDblClick (item) {
      if (item.type === 'dir') {
        this.routerPush(item)
      }
    },
    selectRow (selection, row) {
      for (let i in this.file_table_data) {
        if (this.file_table_data[i].file_name === row.file_name) {
          this.file_table_data[i]._checked = true
        }
      }
    },
    selectRowCancel (selection, row) {
      for (let i in this.file_table_data) {
        if (this.file_table_data[i].file_name === row.file_name) {
          this.file_table_data[i]._checked = false
        }
      }
    },
    selectAll () {
      for (let i in this.file_table_data) {
        this.file_table_data[i]._checked = true
      }
    },
    selectAllCancel () {
      for (let i in this.file_table_data) {
        this.file_table_data[i]._checked = false
      }
    },
    showMessage (type, content) {
      this.message.type = type
      this.message.content = content
      this.message.show = true
    },
    // 前进后退刷新根目录按钮操作
    pathBtn (type) {
      if (type === 'prv') {
        if (this.pathIsStart()) return
        this.path.index -= 1
        this.getFileList(prefix = this.path.history[this.path.index].path, newPath = false)
      } else if (type === 'next') {
        if (this.pathIsEnd()) return
        this.path.index += 1
        this.getFileList(prefix = this.path.history[this.path.index].path, newPath = false)
      } else if (type === 'home') {
        this.path = {
          index: 0,
          history: [
            {
              path: ''
            }
          ]
        }
        this.getFileList(prefix = '', newPath = false)
      } else if (type === 'top') {
        let pArr = this.searchForm.path.split('/')
        if (pArr.length === 0 || (pArr.length === 1 && pArr[0] === '')) return
        pArr.pop(1)
        this.path.index += 1
        this.getFileList(prefix = pArr.join('/'), newPath = false)
      } else {
        this.getFileList(prefix = this.searchForm.path, newPath = false)
      }
    },
    submitFolderFrom () {
      let data = {
        prefix: this.searchForm.path,
        name: this.folder_form.file_name
      }
      this.load.opeDirBtn = true
      createDir(data).then(res => {
        this.load.opeDirBtn = false
        this.fade.folder = false
        this.pathBtn('refresh')
        this.$message.success('创建文件夹成功')
        this.folder_form.file_name = ''
      }).catch(res => {
        this.load.opeDirBtn = false
        if (res.response) {
          this.$message.error(res.response.data)
        } else {
          this.$message.error('创建文件夹失败')
        }
      })
    },
    deleteSubmit () {
      this.$Modal.confirm({
        title: '删除文件/文件夹',
        content: '<p style="color: red">注意！删除文件夹将同时删除文件夹内的所有文件</p>',
        loading: true,
        onOk: () => {
          let data = {
            id: this.currentSupport,
            bucket: this.currentBucket,
            prefix: this.searchForm.path,
            data: []
          }
          for (let i in this.selectData) {
            data.data.push({
              name: this.selectData[i].file_name,
              type: this.selectData[i].type
            })
          }
          this.load.deleteBtn = true
          deleteObjForever(data).then(res => {
            this.$Modal.remove()
            this.load.deleteBtn = false
            this.getFileList()
            this.$message.success('删除成功')
          }).catch(res => {
            this.$Modal.remove()
            this.load.deleteBtn = false
            if (res.response) {
              this.$message.error(res.response.data)
            } else {
              this.$message.error('删除失败')
            }
            console.error(res.response)
          })
        }
      })
    },
    restoreSubmit () {
      this.$Modal.confirm({
        title: '还原文件/文件夹',
        content: '<p style="color: red">注意！还原文件夹将同时还原文件夹内的所有文件</p>',
        loading: true,
        onOk: () => {
          let data = {
            id: this.currentSupport,
            bucket: this.currentBucket,
            prefix: this.searchForm.path,
            data: []
          }
          for (let i in this.selectData) {
            data.data.push({
              name: this.selectData[i].file_name,
              type: this.selectData[i].type
            })
          }
          this.load.restoreBtn = true
          restoreObjDeleted(data).then(res => {
            this.$Modal.remove()
            this.load.restoreBtn = false
            this.pathBtn('refresh')
            this.$message.success('还原成功')
          }).catch(res => {
            this.$Modal.remove()
            this.load.restoreBtn = false
            if (res.response) {
              this.$message.error(res.response.data)
            } else {
              this.$message.error('删除失败')
            }
            console.error(res.response)
          })
        }
      })
    },
    historyArray () {
      let h = []
      for (let i in this.path.history) {
        if (h.indexOf(this.path.history[i].path) === -1) {
          h.push(this.path.history[i].path)
        }
      }
      return h
    },
    download (url, fileName) {
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    handleFileSuccess (res, file) {
      this.load.upload = false
      this.pathBtn('refresh')
    },
    getVersions (row) {
      let params = {
        name: row.prefix ? row.prefix + '/' + row.file_name : row.file_name
      }
      this.load.versionLoading = true
      this.fade.version = true
      fileVersions(params).then(res => {
        this.load.versionLoading = false
        this.versionData = res.data.data
      }).catch(res => {
        this.load.versionLoading = false
        console.error(res.response)
      })
    },
    uploadFile () {
    }
  }
}
</script>

<style lang="less">
  @import '../base.less';
  .backup-manage-index {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .file-path-img{
    margin-top:6px;
    vertical-align:top
  }
  .file-action-btn {
    margin-right: 10px;
  }
  .backup_file_table,
  .backup_file_table th,
  .backup_file_table td {
    border-color: #EBEEF5;
  }
  .backup_file_table .ivu-table-row {
    font-size: 14px;
  }
  .backup_file_table th {
    background-color: #F9F9F9;
  }
  .u-disabled {
    color: #dedada;
    cursor: no-drop;
  }
  .file-handle-box .active {
    cursor: pointer;
    color: #929292;
  }
  .main-bucket {
    padding-bottom: 10px;
  }

  .wl-is-folder {
    cursor: pointer;
    &:hover {
      color: #409EFF;
    }
  }
  // 主体文件列表区
  .wl-main-list {
    padding: 0 20px 20px;
  }
  .wl-list {
    overflow: hidden;
    text-align: center;
    overflow-y: auto;
    .wl-list-item {
      list-style-type:none;
      position: relative;
      float: left;
      padding: 12px;
      width: 94px;
      &:hover .wl-checkbox {
        display: inline-block;
      }
    }
    .wl-checkbox-selected {
      display: inline-block !important;
    }
    .wl-checkbox {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
    }
    .name-col-icon {
      width: 66px;
      height: 66px;
    }
    .list-item-name {
      height: 40px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 12px;
    }
  }
  .transport-list-collapse {
    margin: 8px;
    border: 0;
    .ivu-progress {
      margin-bottom: 0 !important;
    }
  }
  .transport-list-divider {
    margin: 0 15px
  }
  .exec-history-result {
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
  }
</style>
